import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import './ContentArticle.css';

export default function AboutPage() {
  return (
    <main className="content-article">
      <SeoHead
        title="About Letter Quest"
        description="Letter Quest is a free suite of calm daily word games for web and mobile: Word Master, Letter Hive, Word Rungs, Word Square, Hidden Words — with optional accounts and leaderboards."
        path="/about"
      />
      <h1>About Letter Quest</h1>
      <p className="content-article__meta">What we are building and who it is for</p>

      <p className="content-article__lead">
        Letter Quest is a collection of word games designed for quick daily play. You can use the website in your browser
        or install the app from{' '}
        <Link to="/apps">Google Play (Android)</Link>. An iOS release on the App Store is planned. The same kinds of puzzles
        and progression ideas run across both, so you can pick the device that fits your day.
      </p>

      <h2>What you can play here</h2>
      <p>
        The hub highlights five cozy dailies: <strong>Word Master</strong> (five-letter guessing),{' '}
        <strong>Letter Hive</strong> (Spelling Bee–style honeycomb), <strong>Word Rungs</strong> (word ladder),{' '}
        <strong>Word Square</strong> (5×5 fill-in grid), and <strong>Hidden Words</strong> (tap-to-find word search).
        Each offers a <strong>daily puzzle</strong> shared for your calendar day plus <strong>practice</strong> when
        you want extra calm rounds. Additional challenge modes may still be reachable by direct link as we refine the
        lineup.
      </p>

      <h2>Accounts, streaks, and leaderboards</h2>
      <p>
        You can play several games without signing in. Creating a free account lets you sync progress, join{' '}
        <Link to="/leaderboard">leaderboards</Link>, and track streaks across days. We use Firebase Authentication and
        Firestore for accounts and scores; you can read how data is handled in our{' '}
        <Link to="/privacy">Privacy Policy</Link>.
      </p>

      <h2>Why ads</h2>
      <p>
        Running and improving a cross-platform game has ongoing costs. On the web we may show ads (for example through
        Google AdSense) so the experience can stay free for players. Mobile builds may use ad formats appropriate to
        those platforms. We aim to keep gameplay readable and avoid intrusive layouts.
      </p>

      <h2>Help and policies</h2>
      <p>
        New to a mode? See the full <Link to="/how-to-play">How to play</Link> guide. Common questions are answered on the{' '}
        <Link to="/faq">FAQ</Link>. Legal terms live on the <Link to="/terms">Terms of Use</Link> page.
      </p>

      <p className="content-article__footer-links">
        <Link to="/">← Back to games</Link>
      </p>
    </main>
  );
}
